<section>
</section>
<section>
  <!--(columnReorder)="onAllocationReport($event)"-->
  <kendo-grid [data]="AllocationReportHeaderGridData"
              class="AllocationReportSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="AllocationReportGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="AllocationReportGridstate.take"
              [skip]="AllocationReportGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="AllocationReportHeaderGridSortChange($event)"
              (pageChange)="AllocationReportHeaderGridPageChange($event)"
              (dataStateChange)="AllocationReportHeaderGridDataStateChange($event)"
              [filter]="AllocationReportGridSettings.state.filter"
              [loading]="AllocationReportLoading">
    <!--(columnVisibilityChange)="onVisibilityChange($event)"-->
    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{AllocationReportLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{AllocationReportLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of AllocationReportGridSettings.columnsConfig" [headerClass]="'wrapheader-sample-admin-grid'"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'currentCostId'">
        {{dataItem.currentCostId | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isActive'">
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isReorder'">
        <span *ngIf="dataItem.isReorder == 'Yes'" class="red"> {{dataItem.isReorder}}</span>
        <span *ngIf="dataItem.isReorder == 'No'"> {{dataItem.isReorder}}</span>
      </ng-template>
      <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                 *ngIf="col.field == 'isActive'">
      <app-grid-dropdown-filter [filter]="filter" [data]="activeList" textField="name" valueField="activeStatus">
      </app-grid-dropdown-filter>
    </ng-template>-->

    </kendo-grid-column>
    <!--<kendo-grid-command-column title="Action" [width]="80" field="">
    <ng-template kendoGridCellTemplate let-dataItem>
      <button kendoButton class="clearKendoButton btn btn-success btnSizeCls btn-sample-admin-grid-edit"
              (click)="editAllocation(dataItem)">
        <span class=" k-icon k-i-edit k-i-pencil"></span>
      </button>

      <button class="k-button k-grid-remove-command btn-sample-admin-grid-edit" (click)="removeConfirmation(dataItem)">
        <span class="k-icon k-i-trash">
        </span>
      </button>
      <br>
    </ng-template>
  </kendo-grid-command-column>-->
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>

  </kendo-grid>
  <br /><br />
  <div class="form-group col-sm-12 text-center">
    <!--<button kendoButton [disabled]="filterSaveInProcess" class="btn filter-date-btn btn-align-center"
            (click)="AddNewAllocationPopUp()">
      {{AllocationReportLblText.addnewallocationlbl}}<kendo-loader *ngIf="filterSaveInProcess" style="color:blue"></kendo-loader>
    </button>-->
  </div>
</section>
<section class="dialogSection">
  <div class="addnewllaocation-wrapper">
    <kendo-dialog *ngIf="IsAddNewAllocation" title="Add New Budget Association" (close)="close('cancel')" [minWidth]="250" [width]="450">
      <form class="k-form" [formGroup]="AllocationForm">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="lblCls">{{AllocationReportLblText.regcodelbl}} <span class="requiredField">*</span></label>
            <div class="form-inline">
              <input tabindex="1" type="text" kendoTextBox class="kendoInput" name="regCode" [disabled]="this.isEditOn"
                     [(ngModel)]="this.addNewAllocationV.regionCode" (blur)="validateAllocationForm();"
                     [ngClass]="{'borderRed':addNewAllocationV.regionCode ==  '' }"
                     formControlName="regCode" />
              <!--<span title="{{AllocationReportLblText.regcodewarnlbl}}" *ngIf="this.AllocationForm.controls.budgetCode.value" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>-->
            </div>
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">{{AllocationReportLblText.regdesclbl}} <span class="requiredField">*</span></label>
            <div class="form-inline">
              <input tabindex="1" type="text" kendoTextBox class="kendoInput" name="regDesc"
                     [(ngModel)]="this.addNewAllocationV.regionDescription" (blur)="validateAllocationForm();"
                     [ngClass]="{'borderRed':addNewAllocationV.regionDescription ==  '' }"
                     formControlName="regDesc" />
              <!--<span title="{{AllocationReportLblText.regdescwarnlbl}}" *ngIf="this.AllocationForm.controls.regDesc.value" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>-->
            </div>
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">{{AllocationReportLblText.budgetcodelbl}} <span class="requiredField">*</span></label>
            <div class="form-inline">
              <input tabindex="1" type="text" kendoTextBox class="kendoInput" name="budgetCode" [disabled]="this.isEditOn"
                     (blur)="validateAllocationForm();" [(ngModel)]="this.addNewAllocationV.budgetCode"
                     [ngClass]="{'borderRed':addNewAllocationV.budgetCode ==  '' }"
                     formControlName="budgetCode" />
              <!--<span title="{{AllocationReportLblText.budgetcodewarnlbl}}" *ngIf="this.AllocationForm.controls.budgetCode.value" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>-->
            </div>
          </div>
          <div class="form-group col-sm-12 text-center">
            <div class="btn-group" role="group">
              <button tabindex="3" type="Submit" (click)="AddNewAllocation()" class="m-3 btn btn-success dialogBtnSize" kendoButton [disabled]="AddNewAllocationInProgress" #saveForgotPassword>
                {{AllocationReportLblText.saveLbl}}<kendo-loader *ngIf="AddNewAllocationInProgress" style="color:blue"></kendo-loader>
              </button>
              <button kendoButton class="m-3 btn btn-success dialogBtnSize" (click)="close('yes')" primary="true">Cancel</button>

            </div>

          </div>
          <div class="form-group col-sm-12 text-center" *ngIf="isNewLocationComplete">
            <p *ngIf="isNewLocationSuccess" style="color : green;">{{AllocationReportLblText.addNewLocationResponse}}</p>
            <p *ngIf="!isNewLocationSuccess" style="color : red;">{{AllocationReportLblText.addNewLocationResponse}}</p>
          </div>
        </div>
      </form>
    </kendo-dialog>
    <kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
      <p style="margin: 30px; text-align: center;">
        {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
        <b> : {{ gridItemToRemove.budgetCode }}-{{ gridItemToRemove.regionCode }}</b>?
      </p>
      <kendo-dialog-actions>
        <button class='k-button' (click)="confirmRemove(false)">
          {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
        </button>
        <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
          {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>
</section>
